namespace TabAurous.Common {
    export interface ItemLabour {
        ItemTypeId?: number;
        ProductTypeId?: number;
        AttributeId?: number;
        ProcessId?: number;
        ProcessName?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        LabourRate?: number;
        MarkUp?: number;
        LabourAmount?: number;
        CCLabourAmount?: number;
        WstPer?: number;
        WstWt?: number;
    }
}
